module.exports = __webpack_public_path__ + "static/media/redLock.6ecf478c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/redLock.svg
// module id = 492
// module chunks = 0